import { GorgiasFaqsTab } from "../tabs/gorgias-faqs-tab";
import { GorgiasKnowledgeTab } from "../tabs/gorgias-knowledge-tab";
import { GorgiasTagsTab } from "../tabs/gorgias-tags-tab";
import { GorgiasViewsTab } from "../tabs/gorgias-views-tab";
import { createMacrosTab } from "../tabs/macros-tab";
import { ZendeskConversationsTab } from "../tabs/zendesk-conversations-tab";
import { ImportPlatform, ImportTab, PlatformConfig } from "../types";

const GorgiasMacrosTab = createMacrosTab(ImportPlatform.GORGIAS);
const ZendeskMacrosTab = createMacrosTab(ImportPlatform.ZENDESK);
const ReamazeMacrosTab = createMacrosTab(ImportPlatform.REAMAZE);
const RichPanelMacrosTab = createMacrosTab(ImportPlatform.RICHPANEL);

export const PLATFORM_CONFIGS: PlatformConfig[] = [
  {
    id: ImportPlatform.GORGIAS,
    displayName: "Gorgias",
    tabs: [
      { key: ImportTab.MACROS, label: "Macros", component: GorgiasMacrosTab },
      { key: ImportTab.TAGS, label: "Tags", component: GorgiasTagsTab },
      { key: ImportTab.FAQS, label: "FAQs", component: GorgiasFaqsTab },
      { key: ImportTab.VIEWS, label: "Views", component: GorgiasViewsTab },
      {
        key: ImportTab.KNOWLEDGE,
        label: "Knowledge",
        component: GorgiasKnowledgeTab,
      },
    ],
  },
  {
    id: ImportPlatform.ZENDESK,
    displayName: "Zendesk",
    tabs: [
      { key: ImportTab.MACROS, label: "Macros", component: ZendeskMacrosTab },
      {
        key: ImportTab.CONVERSATIONS,
        label: "Conversations",
        component: ZendeskConversationsTab,
      },
    ],
  },
  {
    id: ImportPlatform.REAMAZE,
    displayName: "Reamaze",
    tabs: [
      { key: ImportTab.MACROS, label: "Macros", component: ReamazeMacrosTab },
    ],
  },
  {
    id: ImportPlatform.RICHPANEL,
    displayName: "RichPanel",
    tabs: [
      { key: ImportTab.MACROS, label: "Macros", component: RichPanelMacrosTab },
    ],
  },
];

export function getPlatformConfig(
  platformId: ImportPlatform,
): PlatformConfig | undefined {
  return PLATFORM_CONFIGS.find((config) => config.id === platformId);
}
